import ContextMenu from '@/componentMenus/Context/ContextMenu.vue'
import { Event, User, Post, Group, ConversationMessage, Conversation } from '@/classes'
import { defineStore } from 'pinia'
import { ContextActions } from '@/utils/useContext'

export default defineStore('context', () => {
  const componentMenu: Ref<typeof ContextMenu | null> = ref(null)
  const post: Ref<Post | null> = ref(null)
  const postParent: Ref<Post | null> = ref(null)
  const event: Ref<Event | null> = ref(null)
  const user: Ref<User | null> = ref(null)
  const group: Ref<Group | null> = ref(null)
  const message: Ref<ConversationMessage | null> = ref(null)
  const conversation: Ref<Conversation | null> = ref(null)

  const options: Ref<{
    onReact?: (() => void)
    onAnswer?: (() => void)
    onRetry?: (() => void)
    onEdit?: (() => void)
    onReactList?: (() => void)
    onCheers?: (() => void)
  } | null> = ref(null)

  const setComponent = (c: typeof ContextMenu) => {
   componentMenu.value = c
  }

  const showContextMenu = (
    params?: {
      user?: User
      event?: Event
      group?: Group
      post?: Post
      postParent?: Post
      conversation?: Conversation
      message?: ConversationMessage
    },
    types?: (keyof typeof ContextActions)[],
    o?: {
      id?: string
      onReact?: () => void
      onAnswer?: () => void
      onRetry?: () => void
      onEdit?: () => void
      onReactList?: () => void
      onCheers?: () => void
    }
  ) => {
    user.value = params?.user || null
    event.value = params?.event || null
    post.value = params?.post || null
    postParent.value = params?.postParent || null
    group.value = params?.group || null
    message.value = params?.message || null
    conversation.value = params?.conversation || null
    options.value = o ?? null

    if (componentMenu.value) {
      componentMenu.value.onDisplay(types, o?.id)
    }
  }

  const displayReactions = (params?: {
    post?: Post | null
    message?: ConversationMessage | null
  },) => {
    post.value = params?.post ?? null
    message.value = params?.message ?? null

    if (componentMenu.value) {
      componentMenu.value.onShowReactions()
    }
  }

	return {
    event, user, post, group, message, options, conversation, postParent,
    showContextMenu, setComponent, displayReactions
	}
})
